export const validateFormData = (
  formData: {
    expectedParticipants?: number;
    maxParticipants?: number;
  },
  t: (key: string) => string
): Record<string, string> => {
  const validationErrors: Record<string, string> = {};

  if (formData.maxParticipants === undefined || formData.maxParticipants === null) {
    validationErrors.maxParticipants = t('courseForm.validation.maxParticipantsRequired');
  } else if (formData.maxParticipants > 1000) {
    validationErrors.maxParticipants = t('courseForm.validation.maxParticipantsTooHigh');
  }

  if (
    formData.expectedParticipants !== undefined &&
    formData.expectedParticipants !== null &&
    formData.maxParticipants !== undefined &&
    formData.maxParticipants !== null &&
    formData.expectedParticipants > formData.maxParticipants
  ) {
    validationErrors.expectedParticipants = t(
      'courseForm.validation.expectedParticipantsExceedsMax'
    );
  }

  return validationErrors;
};
